import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import axios from 'axios'
import moment from 'moment'
import { queryClient } from '../../config'
import getBaseURL from '../../config/baseURL'


let Clio = ({ className }) => {
  const [region, setRegion] = useState('app.clio.com')
  const [hasAuth, setHasAuth] = useState(false)
  const [lastUpdate, setLastUpdate] = useState(null)

  const ferchClio = async () => {
    const { data } = await axios.get('/api/clio')
    setRegion(data.region)
    setHasAuth(data.hasAuth)
    if (data.lastUpdate) {
      setLastUpdate(data.lastUpdate)
    }
  }

  const ferchToken = async (code) => {
    try {
      await axios.get('/api/clio/token?code=' + code)
      await ferchClio()
    } catch (e) {

    }
  }
  useEffect(() => {
    ferchClio()

    const code = new URLSearchParams(window.location.search).get('code')
    if (code) {
      ferchToken(code)
    }

  }, [])

  const login = async (event) => {
    const { data } = await axios.post('/api/clio', {
      region,
    })
    const state = {
      tenancy: window.tenancy,
      back_uri: window.location.href,
      authorization: axios.defaults.headers.common['Authorization'],
      action: 'active',
    }

    const REDIRECT_URI = getBaseURL() + '/api/auth/clio/callback'

    window.location.href = `https://${region}/oauth/authorize?response_type=code&client_id=${data.key}&redirect_uri=${REDIRECT_URI}&state=${encodeURI(
      JSON.stringify(state))}`
  }

  const refresh = async () => {
    if (hasAuth) {
      const { data } = await axios.post('/api/clio/refresh')
      setLastUpdate(data.lastUpdate)

      const URL = '/api/types?fields=name,type,_id'
      const { data: types } = await axios.get(URL)
      await queryClient.clear()
      await queryClient.setQueryData(URL, types)
    } else {
      const { data } = await axios.get('/api/clio')
      const state = {
        tenancy: window.tenancy,
        back_uri: window.location.href,
        authorization: axios.defaults.headers.common['Authorization'],
        action: 'refresh',
      }

      const REDIRECT_URI = getBaseURL() + '/api/auth/clio/callback'

      window.location.href = `https://${region}/oauth/authorize?response_type=code&client_id=${data.key}&redirect_uri=${REDIRECT_URI}&state=${encodeURI(
        JSON.stringify(state))}`
    }
  }

  const deActivate = async () => {
    await axios.post('/api/clio/deactivate')
    setRegion('app.clio.com')
    setHasAuth(false)
    setLastUpdate(null)
  }

  return (
    <div className={'container-fluid py-2'}>
      <label className={'mb-2 text-uppercase'}>{'Clio configuration'}</label>
      <div className={classNames('w-100 border border-dark p-4', className)}>
        <div className={'row'}>
          <div className={'col-3'}>
            <div className="form-group">
              <label htmlFor="displayName">{'Application Region'}</label>
              <select className="form-control rounded-0" id="applicationRegion"
                      value={region}
                      onChange={event => {
                        setRegion(event.target.value)
                      }}>
                <option value={'app.clio.com'}>{'United States'}</option>
                <option value={'ca.app.clio.com'}>{'Canada'}</option>
                <option value={'au.app.clio.com'}>{'Australia'}</option>
                <option value={'eu.app.clio.com'}>{'Europe'}</option>
              </select>
            </div>
            <div className={'row'}>
              <div className="col-12">
                {lastUpdate ? (
                  <p>Models last refreshed on {moment(lastUpdate).format('MM/DD/YYYY')} at {moment(lastUpdate).format('hh:mm A')}</p>) : (
                  <p>Models have not yet been imported.</p>)}

              </div>
              <div className="col-12">
                {lastUpdate ? (<button
                  className="btn btn-secondary dart-btn text-uppercase w-75"
                  onClick={refresh}>
                  Refresh Integration
                </button>) : (<button
                  className="btn btn-secondary dart-btn text-uppercase w-75"
                  onClick={login}>
                  Activate Integration
                </button>)}
              </div>

              {lastUpdate && (<div className={'col-12'}>
                <button
                  className="btn btn-secondary dart-btn text-uppercase w-75 mt-3"
                  onClick={deActivate}>
                  DEACTIVATE INTEGRATION
                </button>
              </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Clio = styled(Clio)`
  background-color: ${props => props.theme.colorTable.plain} !important;
  border-color: ${props => props.theme.colorTable.border} !important;
  color: ${props => props.theme.colorTable.textLight} !important;
`
export default Clio
